// packages/game/src/scenes/craps/DiceOverlayScene.ts
//
// Tiny overlay scene that hosts ONLY the two visual Dice. Sits above
// CrapsTableScene + CrapsUIScene so dice mid-throw render on top of pills,
// history, and the player-card modal. The DiceThrow controller (in
// TableScene) drives these via the DiceVisual interface; pointer input
// stays in TableScene where the gesture hit rect lives.
//
// Created lazily in create() because diceSize / home position depend on the
// table layout. The bridge initializer (main.ts) calls `setupDice` after
// TableScene's create() has run and produced its layout.
import Phaser from 'phaser';
import { Dice } from '../../objects/Dice.js';

export class DiceOverlayScene extends Phaser.Scene {
  dice1: Dice | undefined;
  dice2: Dice | undefined;

  constructor() {
    super('CrapsDiceOverlayScene');
  }

  create() {
    // Transparent — we only paint the dice we add later via setupDice.
    this.cameras.main.setBackgroundColor('rgba(0,0,0,0)');
  }

  setupDice(opts: {
    home: { x: number; y: number; halfSep: number };
    diceSize: number;
  }): { dice1: Dice; dice2: Dice } {
    this.dice1?.destroy();
    this.dice2?.destroy();
    this.dice1 = new Dice(this, opts.home.x - opts.home.halfSep, opts.home.y, opts.diceSize);
    this.dice2 = new Dice(this, opts.home.x + opts.home.halfSep, opts.home.y, opts.diceSize);
    return { dice1: this.dice1, dice2: this.dice2 };
  }
}
